import { FC } from 'react'

import { LinkProps } from '../Link'
import { Icons } from '../Icon'

import * as SC from './styled'

export type DownloadFilesProps = {
  className?: string
  title: string
  items: Array<{
    label: string
    link: LinkProps
  }>
}

const DownloadFiles: FC<DownloadFilesProps> = ({ title, items, className }) => {
  return (
    <SC.DownloadFilesContainer className={className}>
      <SC.Title>{title}:</SC.Title>
      <SC.DownloadFilesList>
        {items?.map((item, index) => (
          <li key={index}>
            <SC.DownloadLink {...item.link}>
              {item.label}
              <SC.DownloadIcon icon={Icons.download} width={15} height={14} />
            </SC.DownloadLink>
          </li>
        ))}
      </SC.DownloadFilesList>
    </SC.DownloadFilesContainer>
  )
}

export default DownloadFiles
